// The countdown a grandfathered restaurant sees in its last fortnight of
// complimentary Premium (decision 1, 2026-09-07), plus the past-due warning a
// paying one sees while Stripe retries its card. Both link to the plan page.

import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useBilling } from '@/state/useBilling'
import { PLAN_PAGE_PATH } from './UpgradeGate'

const BANNER_WINDOW_MS = 14 * 24 * 60 * 60 * 1000

export function formatPlanDate(iso: string): string {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return ''
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })
}

export function GrandfatherBanner() {
  const { t } = useTranslation('billing')
  const { loaded, plan, source, status, compSource, compExpiresAt } = useBilling()
  if (!loaded) return null

  if (source === 'stripe' && status === 'past_due') {
    return (
      <div role="status" className="border-b border-amber-500/40 bg-amber-500/10 px-4 py-2 text-sm text-amber-700 dark:text-amber-300">
        {t('pastDueBanner')}{' '}
        <Link to={PLAN_PAGE_PATH} className="font-semibold underline">{t('pastDueAction')}</Link>
      </div>
    )
  }

  if (plan === 'premium' && source === 'comp' && compSource === 'grandfathered' && compExpiresAt) {
    const until = new Date(compExpiresAt).getTime()
    if (!Number.isNaN(until) && until - Date.now() <= BANNER_WINDOW_MS) {
      return (
        <div role="status" className="border-b border-amber-500/40 bg-amber-500/10 px-4 py-2 text-sm text-amber-700 dark:text-amber-300">
          {t('grandfatherBanner', { date: formatPlanDate(compExpiresAt) })}{' '}
          <Link to={PLAN_PAGE_PATH} className="font-semibold underline">{t('grandfatherAction')}</Link>
        </div>
      )
    }
  }

  return null
}
